{
  "addproductbutton": "Add Product",
  "refreshPriceMasterButton": "PriceMaster",
  "updateproductbutton": "Update",
  "deleteproductbutton": "Delete",
  "productTableHeader": {
    "availability": "Availability",
    "brand": "Brand",
    "languages": "Languages",
    "productName": "Product name",
    "salesChannels": "Sales channels",
    "sku": "SKU",
    "priceType": "Pricing type",
    "price": "Price",
    "priceWithCurrency": "Price ({{currency}})",
    "vat": "VAT %"
  },
  "headerTitle": "Product Catalog",
  "productsTable": {
    "salesChannelAndMore": "{{salesChannel}} and {{leftCount}} more",
    "variants": "variants",
    "savePriceTitle": "Update price"
  },
  "filter": {
    "clearFilters": "Clear filters",
    "textsearchtitle": "Search",
    "textsearchplaceholder": "Search...",
    "categoryFilterTitle": "Filter by category",
    "categoryPlaceholder": "Category",
    "languagefiltertitle": "Filter by language",
    "languagefiltertplaceholder": "Select",
    "brandfiltertitle": "Filter by brand",
    "brandfilterplaceholder": "Brand"
  },
  "sku_one": "{{count}} SKU",
  "sku_other": "{{count}} SKUs",
  "product_one": "{{count}} Product",
  "product_other": "{{count}} Products",
  "product_availabilities": {
    "available": "Available",
    "not_available": "Not available",
    "limited": "Limited availability",
    "out_of_stock": "Out of stock"
  },
  "priceTypes": {
    "monthly_12": "12 months",
    "monthly_24": "24 months",
    "monthly_30": "30 months",
    "monthly_36": "36 months",
    "monthly_48": "48 months",
    "once": "One time"
  },
  "showVariants": "Show Variants",
  "hideVariants": "Hide Variants",
  "select": "Select",
  "selectAll": "Select All",
  "selected": {
    "addToChannel": "Edit sales channels",
    "removeFromSalesChannel": "Remove From Channel",
    "editProduct": "Edit Product",
    "delete": "Delete",
    "cancel": "Cancel",
    "skuSelected_one": "{{count}} SKU selected",
    "skuSelected_other": "{{count}} SKUs selected"
  },
  "delete_product_confirmation": {
    "title_one": "Delete {{count}} variant",
    "title_other": "Delete {{count}} variants",
    "content_one": "Are you sure you want to delete {{count}} variant? A variant will be completely deleted.",
    "content_other": "Are you sure you want to delete {{count}} variants? Variants will be completely deleted.",
    "buttons": {
      "cancel": "Cancel",
      "delete": "Delete"
    }
  },
  "pagination": {
    "show": "Show"
  },
  "notification": {
    "skuDeleted_one": "{{count}} SKU deleted successfully",
    "skuDeleted_other": "{{count}} SKUs deleted successfully",
    "refreshPriceMasterPricesSuccessful": "Update requested from PriceMaster for Norwegian Telia Finance acquisition prices",
    "refreshPriceMasterPricesFailed": "Update request to PriceMaster failed, prices not updated",
    "errorDeletingSalesChannel": "Sales channel not found",
    "errorAddingSalseChannel": "Adding sales channel: {{errorMsg}}",
    "errorPriceBlank": "Price must not be blank",
    "errorUpdatingPrice": "Error occurred while updating price",
    "errorFetch": "Error occurred while fetching products",
    "errorAddingMaterialCode": "Error occurred while adding material codes",
    "errorFetchingMaterialCodes": "Error occurred while fetching material codes",
    "errorDeletingProducts": "Error occurred while deleting products",
    "warningMaintenanceModeEnabled": "The system is currently under maintenance and in read-only mode"
  },
  "sales_channel_drawer": {
    "title": "Edit sales channels for this bundle",
    "addedTo": "Added to {{addedCount}}/{{totalCount}}",
    "add": "Add",
    "cancel": "Cancel",
    "addToAll": "Add to all",
    "vatInputPlaceholder": "VAT",
    "guideText": "Search for channels and click + on the right side to add the channel.",
    "close": "Close",
    "vat": "VAT",
    "salesPrice": "Sales price excluding VAT ({{currency}}/month)",
    "paymentType": "Payment type",
    "vatLabel": "VAT (%)",
    "save": "Save",
    "material_code_not_found": "Variant {{variant_sku}} has not been given a material code for the country this sales channel is set to be in and thus cannot be added to this sales channel"
  }
}
